import * as React from "react";
import axios from "axios";
import * as settings from "../settings";
import {
  Grid,
  Typography,
  Card,
  CardActions,
  CardContent,
} from "@mui/material";
import { useRecoilState, useRecoilValue } from "recoil";
import { Plan, Plans } from "../atom/atom";

import PlanButton from "./Map/LoadPlanButton";
import TrashPlan from "./Dashboard/TrashPlan";
import CardColorPicker from "./Dashboard/CardColorPicker";

export default function PlansTable(props) {
  const plan = useRecoilValue(Plan);
  const [plans, setPlans] = useRecoilState(Plans);

  function getPlans() {
    // this isn't actually authenticating, just pulling all the plans - need to fix this
    axios
      .post(`${settings.API_SERVER}/api/auth/plans/`, {
        user: localStorage.getItem("username"),
      })
      .then((res) => {
        setPlans(res.data.data);
      })
      .catch((e) => {
        console.log("error getting plans", e);
      });
  }

  React.useEffect(() => {
    getPlans();
  }, [plan]);

  if (!plans)
    return (
      <Typography variant="body1">
        Get started by creating a new plan.
      </Typography>
    );
  else
    return (
      <Grid container spacing={2}>
        {plans.map((row) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={row.id}>
            <Card>
              <CardColorPicker plan={row.id} color={row.color} />
              <CardContent sx={{ minHeight: "120px" }}>
                <Typography gutterBottom variant="h5" component="div">
                  {row.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {`Last updated ${row.formatted_date}`}
                </Typography>
              </CardContent>
              <CardActions>
                <PlanButton id={row.id} settings={props} />
                <TrashPlan id={row.id} settings={props} updateFunc={getPlans} />
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
}
